import React, { useEffect, useState } from 'react'
import * as con from "../Constants"
import { isNullOrUndefined } from '../utils/generalFunctions'
import { RefSelectedAnnotationResultHit } from '../hooks/AnnotationResultsHook';
import { Col, Row, Typography } from 'antd';
import { formatEValue, constructAlignmentString, extractIdFromTaxonomicSequence } from '../utils/chartFunctions';
import { RefLanguage } from '../hooks/LanguageHooks';
import TextArea from 'antd/es/input/TextArea';

const { Title, Text } = Typography;


function AlignmentResultDetail() {

    const selectedResult = RefSelectedAnnotationResultHit()

    const [taxonomicData, setTaxonomicData] = useState({})

    const i18n = RefLanguage()


    useEffect(() => {

        if (!isNullOrUndefined(selectedResult))
            setTaxonomicData(selectedResult[con.ARC_TAXONOMY])
        else
            setTaxonomicData({})

    }, [selectedResult])


    return (<div>
        {
            isNullOrUndefined(selectedResult)
                ? <div style={{ 
                    padding: "24px", 
                    textAlign: "center", 
                    color: "#666",
                    backgroundColor: "#fafafa",
                    borderRadius: "8px",
                    border: "1px dashed #d9d9d9"
                  }}>
                    <Typography>
                        <Title level={4} style={{ color: "#999", marginBottom: "8px" }}>
                            {i18n.t("noResultSelected")}
                        </Title>
                        <Text type="secondary">
                            {i18n.t("selectResultFromChart")}
                        </Text>
                    </Typography>
                  </div>
                : <div>
                    <Typography >
                        <Title level={4} style={{ marginTop: 0, paddingTop: 0 }}>{extractIdFromTaxonomicSequence(selectedResult[con.ARC_SSQID])}</Title>
                        
                        {/* Alignment Statistics */}
                        <div data-tour="alignment-stats" style={{ marginBottom: '16px', marginTop: '8px' }}>
                            <Text 
                                style={{ 
                                    fontSize: '13px', 
                                    color: '#666',
                                    fontWeight: 'normal'
                                }}
                            >
                                Similarity: <Text style={{ fontSize: '13px', color: '#333' }}>
                                    {parseFloat(selectedResult[con.ARC_PIDENT]).toFixed(2)}%</Text>
                                <span style={{ margin: '0 12px', color: '#999' }}>•</span>
                                Coverage: <Text style={{ fontSize: '13px', color: '#333' }}>
                                    {parseFloat(selectedResult[con.ARC_QCOVS]).toFixed(2)}%</Text>
                                <span style={{ margin: '0 12px', color: '#999' }}>•</span>
                                E-value: <Text style={{ fontSize: '13px', color: '#333' }}>
                                    {formatEValue(selectedResult[con.ARC_EVALUE])}
                                </Text>
                                <span style={{ margin: '0 12px', color: '#999' }}>•</span>
                                Target length: <Text style={{ fontSize: '13px', color: '#333' }}>
                                    {selectedResult[con.ARC_TARGET_LENGTH]} bp</Text>
                            </Text>
                        </div>
                    </Typography>
                    <Row data-tour="taxonomy-info">
                        <Col span={1} />
                        <Col span={3}>
                            <Text className='taxonomicTagName'>{i18n.t("kingdom")}: </Text>
                            <Text className='taxonomicTagValue'>{isNullOrUndefined(taxonomicData[con.KINGDOM]) ? "---" : taxonomicData[con.KINGDOM]}</Text>
                        </Col>
                        <Col span={3}>
                            <Text className='taxonomicTagName'>{i18n.t("phylum")}: </Text>
                            <Text className='taxonomicTagValue'>{isNullOrUndefined(taxonomicData[con.PHYLUM]) ? "---" : taxonomicData[con.PHYLUM]}</Text>
                        </Col>
                        <Col span={3}>
                            <Text className='taxonomicTagName'>{i18n.t("class")}: </Text>
                            <Text className='taxonomicTagValue'>{isNullOrUndefined(taxonomicData[con.CLASS]) ? "---" : taxonomicData[con.CLASS]}</Text>
                        </Col>
                        <Col span={3}>
                            <Text className='taxonomicTagName'>{i18n.t("order")}: </Text>
                            <Text className='taxonomicTagValue'>{isNullOrUndefined(taxonomicData[con.ORDER]) ? "---" : taxonomicData[con.ORDER]}</Text>
                        </Col>
                        <Col span={4}>
                            <Text className='taxonomicTagName'>{i18n.t("family")}: </Text>
                            <Text className='taxonomicTagValue'>{isNullOrUndefined(taxonomicData[con.FAMILY]) ? "---" : taxonomicData[con.FAMILY]}</Text>
                        </Col>
                        <Col span={3}>
                            <Text className='taxonomicTagName'>{i18n.t("genus")}: </Text>
                            <Text className='taxonomicTagValue'>{isNullOrUndefined(taxonomicData[con.GENUS]) ? "---" : taxonomicData[con.GENUS]}</Text>
                        </Col>
                        <Col span={3}>
                            <Text className='taxonomicTagName'>{i18n.t("species")}: </Text>
                            <Text className='taxonomicTagValue'>{isNullOrUndefined(taxonomicData[con.SPECIES]) ? "---" : taxonomicData[con.SPECIES]}</Text>
                        </Col>
                        <Col span={1} />
                    </Row>

                    <div data-tour="alignment-visualization" style={{ paddingLeft: "2vw", paddingRight: "2vw", marginTop: "8px", marginBottom: "24px" }}>
                        <TextArea
                            value={constructAlignmentString(selectedResult[con.ARC_ALIGNMENT])}
                            style={{
                                fontFamily: 'monospace', // Sets a monospace font for better alignment
                                whiteSpace: 'pre',       // Keeps whitespace and allows horizontal scroll
                                overflowX: 'auto',       // Enables horizontal scroll
                                overflowY: 'hidden',     // Disables vertical scroll
                                resize: 'none'           // Disables resizing
                            }}
                            rows={3} />
                    </div>
                </div>
        }
    </div>)
}

export default AlignmentResultDetail
